import { DELETE, POST, PUT } from "api/config";

export const create = async (data) => await POST("/mypage/portfolio/my", data);

export const remove = async (id) => await DELETE(`/mypage/portfolio/my/${id}`);

export const update = async ({ id, data }) =>
  await PUT(`/mypage/portfolio/my/${id}`, data);
